export const FISCAL_STATUSES = ['queued', 'sent', 'accepted', 'error'] as const;
export type FiscalStatus = (typeof FISCAL_STATUSES)[number];
export type FiscalType = 'sale' | 'refund';

export const fiscalColors: Record<FiscalStatus, string> = {
  queued: 'bg-muted text-muted-foreground',
  sent: 'bg-warning/15 text-warning',
  accepted: 'bg-success/15 text-success',
  error: 'bg-destructive/15 text-destructive',
};

export interface FiscalReceiptItem {
  name: string;
  quantity: number;
  total: number;
  mxik?: string | null;
  package_code?: string | null;
}

export interface FiscalReceipt {
  id: number;
  merchant_id: number;
  murabaha_case_id: number;
  receipt_type: FiscalType;
  status: FiscalStatus;
  amount_tiyin: number;
  vat_percent: number;
  vat_tiyin: number;
  terminal_id: string | null;
  receipt_id: string | null;
  fiscal_sign: string | null;
  qr_url: string | null;
  order_number: string | null;
  items: FiscalReceiptItem[];
  error_message: string | null;
  attempts: number;
  sent_at: string | null;
  accepted_at: string | null;
  merchant?: { id: number; name: string; inn: string | null };
  created_at: string | null;
  updated_at: string | null;
}

/** Amounts travel in tiyin (1/100 so'm). */
export const tiyinToSom = (tiyin: number) => tiyin / 100;
